export default __webpack_public_path__ + "static/media/service.0a990590.svg";